import controller from './orders.controller';
import template from './orders.view.html';

let OrdersComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default OrdersComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/orders/orders.component.js
 **/